import { CrossSellingPointer } from "../../others";
import { RCL } from ".";
import $ from "jquery";
/**
 * Assign in Classic Editor (needs to be extract as class to avoid multiple event triggers).
 */

class CrossRclClassicEditorAssign {
  static onChange() {
    new CrossSellingPointer($(this), RCL, "assign");
    $(CrossRclClassicEditorAssign.SELECTOR).off("change", CrossRclClassicEditorAssign.onChange);
  }

  static bind() {
    CrossSellingPointer.isActionAvailable(RCL, "assign") && $(this.SELECTOR).one("change", this.onChange);
  }

}

CrossRclClassicEditorAssign.SELECTOR = 'body.wp-admin.post-php:not(.post-type-attachment) #categorychecklist input[type="checkbox"]';
export { CrossRclClassicEditorAssign };